import { useQuery } from '@tanstack/react-query';
import { screeningTestsApi } from '../../../apis';

export const useQueryScreeningFlowDraftTestRuns = (draftId: number) =>
  useQuery({
    queryKey: ['screeningFlowDraftTestRuns', draftId],
    queryFn: () => screeningTestsApi.findScreeningTestsForDraft({ draftId }),
    enabled: !Number.isNaN(draftId),
  });
